import { Components } from "@thisgorilla/primate-ds";
import { useRef } from "react";
import { useTheme } from "styled-components";

import { LabelContainer } from "../../../commonStyles";
import { validImageFileTypes } from "../../../utils";
import GradientCard from "../GradientCard";
import ImgPreview from "../ImgPreview";
import { FlexRow } from "../Styles";
import AudioBackgroundProps from "./AudioBackground";
import {
  AddImage,
  BackgroundImageContainer,
  Container,
  HiddenInput,
} from "./style";

const AudioBackground = ({
  gradients,
  audioBackgroundImage,
  image = "",
  onDelete,
  onImageUploaded,
  onGradientClick,
}: AudioBackgroundProps.IProps) => {
  const { typography, Color } = useTheme();
  const fileInputRef = useRef<HTMLInputElement>(null);

  const isImageSelected = audioBackgroundImage.background_type === "image";

  return (
    <>
      <LabelContainer>
        <Components.Text
          style={{ tokenStyle: typography.Heading.XXS }}
          text="Background image"
          lineHeight="line-height-50"
          fontWeight="font-weight-semibold"
        />
      </LabelContainer>
      <BackgroundImageContainer>
        <Components.Text
          style={{ tokenStyle: typography.Body.S }}
          text="Upload a background or choose one of our presets below."
          lineHeight="line-height-75"
          fontWeight="font-weight-semibold"
          color={Color.text["text-emphasize-brand-bolder"].value}
        />
        <FlexRow $gapInPx={8}>
          {isImageSelected ? (
            <ImgPreview img={image} onDelete={onDelete} />
          ) : (
            <Components.Tooltip type="label" label="Upload image">
              <AddImage>
                <Components.IconButton
                  iconType="Plus"
                  onClick={() => fileInputRef?.current?.click()}
                  disabled={false}
                  kind="Tertiary"
                  size="Small"
                />
              </AddImage>
            </Components.Tooltip>
          )}
          <Container>
            {gradients.map((gradient, index) => {
              const gradientBg = `linear-gradient(${gradient?.gradient?.rotation}deg, ${gradient?.gradient?.color_1} 0%, ${gradient?.gradient?.color_2} 100%)`;
              return (
                <GradientCard
                  key={index}
                  background={gradientBg}
                  text={gradient.gradient.color_name}
                  selected={
                    audioBackgroundImage.background_type === "image"
                      ? false
                      : JSON.parse(audioBackgroundImage.background_value)
                          .color_name === gradient?.gradient?.color_name
                  }
                  onClick={() => onGradientClick(gradient.gradient)}
                />
              );
            })}
          </Container>
        </FlexRow>
      </BackgroundImageContainer>
      {!isImageSelected && (
        <HiddenInput
          type="file"
          multiple
          disabled={false}
          onChange={onImageUploaded}
          ref={fileInputRef}
          id="image-upload"
          accept={validImageFileTypes.join(",")}
        />
      )}
    </>
  );
};

export default AudioBackground;
